module.exports = __webpack_public_path__ + "img/3.8b2d0904.png";